export default function Products() {
  return (
    <section id="products" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="flex flex-col lg:flex-row justify-between items-start mb-20 gap-8">
          <h2 className="text-5xl lg:text-6xl font-bold text-[#1a2847] lg:w-2/5">
            Our Products
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed lg:w-3/5">
            We develop powerful iOS applications that combine security, performance, and user-friendly design. Our products are trusted by thousands of users who value their privacy and device optimization.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-[#7c3aed] to-[#1e40af] p-12 min-h-[500px] flex flex-col justify-between">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-10 right-10 w-40 h-40 bg-white rounded-full"></div>
              <div className="absolute bottom-20 left-10 w-32 h-32 bg-white rounded-lg rotate-45"></div>
              <div className="absolute top-1/2 right-1/4 w-24 h-24 bg-white rounded-full"></div>
            </div>
            
            <div className="relative z-10">
              <div className="w-16 h-16 flex items-center justify-center bg-[#06b6d4] rounded-2xl mb-6">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              
              <h3 className="text-4xl font-bold text-white mb-6">
                VPN Protection
              </h3>
              
              <p className="text-white/90 text-lg leading-relaxed">
                Our VPN application provides military-grade encryption to protect your online privacy and secure your internet connection. Browse anonymously, access content from anywhere, and shield your data from prying eyes. With lightning-fast servers across the globe and a strict no-logs policy, your digital footprint remains completely private and secure.
              </p>
            </div>
            
            <div className="relative z-10 mt-8">
              <img
                src="https://public.readdy.ai/ai/img_res/dc0acd645d1014d065d0f78e5f9d4b89.jpg"
                alt="VPN Protection"
                className="w-full h-48 object-cover rounded-2xl"
              />
            </div>
          </div>
          
          <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-[#f97316] to-[#ec4899] p-12 min-h-[500px] flex flex-col justify-between">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-10 left-10 w-40 h-40 bg-white rounded-full"></div>
              <div className="absolute bottom-20 right-10 w-32 h-32 bg-white rounded-lg rotate-45"></div>
              <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-white rounded-full"></div>
            </div>
            
            <div className="relative z-10">
              <div className="w-16 h-16 flex items-center justify-center bg-[#fbbf24] rounded-2xl mb-6">
                <i className="ri-brush-line text-3xl text-white"></i>
              </div>
              
              <h3 className="text-4xl font-bold text-white mb-6">
                Device Cleaner
              </h3>
              
              <p className="text-white/90 text-lg leading-relaxed">
                Keep your iOS device running at peak performance with our intelligent Cleaner application. Remove junk files, optimize storage, and free up valuable space with just a few taps. Our advanced algorithms identify unnecessary data, duplicate photos, and cached files, ensuring your device stays fast, efficient, and clutter-free for an optimal user experience.
              </p>
            </div>
            
            <div className="relative z-10 mt-8">
              <img
                src="https://readdy.ai/api/search-image?query=clean%20minimalist%20mobile%20phone%20optimization%20icon%20with%20sparkles%20and%20broom%20symbol%20orange%20and%20pink%20gradient%20device%20cleaning%20concept%20modern%20illustration%20simple%20background%20technology%20visual%20professional%20design%20high%20quality%20render&width=400&height=300&seq=cleaner001&orientation=landscape"
                alt="Device Cleaner"
                className="w-full h-48 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}